<template>
  <div id="airplane" class="airplane">
    <wing :info="{ ...wingsInfo, direction: 'left' }" />
    <div id="deck" class="deck">
      <!-- Columns -->
      <div
        class="deck-row rows-display"
        :style="{
          'grid-template-columns': Array.from({ length: deckConfiguration.width })
            .map(() => 'auto')
            .join(' '),
        }"
      >
        <div
          v-for="(col, index) in columns"
          :key="'col-def-' + (col.name || index)"
          class="deck-col"
        >
          <div class="map-block rows-display-element">
            <span class="block-info">
              {{ col.name }}
            </span>
          </div>
        </div>
      </div>
      <!-- Seats and facilities -->
      <div v-for="row in allRows" :key="'row-' + row" class="deck-row-container">
        <deck-row
          v-if="aircraftMap[row] && aircraftMap[row].exits"
          :deckWidth="deckConfiguration.width"
          :rowObjects="aircraftMap[row]"
          :columns="columns"
          :numberedRow="Number(numberedRows[row])"
          :selectedSeats="selectedSeats"
          :handleSeatSelection="handleSeatSelection"
          isExitRow
        />
        <deck-row
          v-if="aircraftMap[row] && aircraftMap[row].blocks"
          :deckWidth="deckConfiguration.width"
          :rowObjects="aircraftMap[row]"
          :columns="columns"
          :numberedRow="Number(numberedRows[row])"
          :selectedSeats="selectedSeats"
          :handleSeatSelection="handleSeatSelection"
          :currentTravelerChoosing="currentTravelerChoosing"
        />
      </div>
    </div>
    <wing :info="{ ...wingsInfo, direction: 'right' }" />
  </div>
</template>

<script>
import Wings from '@liveflight/components/blocks/seat-map/deck/wing.vue';
import DeckRow from '@liveflight/components/blocks/seat-map/deck/deck-row.vue';

export default {
  name: 'deck',
  components: {
    'deck-row': DeckRow,
    wing: Wings,
  },
  props: {
    deckConfiguration: Object,
    currentTravelerChoosing: {
      type: String,
      default: () => '',
    },
    mappedDeck: Object,
    selectedSeats: Object,
    handleSeatSelection: Function,
  },
  computed: {
    exitRows() {
      if (!this.deckConfiguration.exitRowsX) return [];
      return this.deckConfiguration.exitRowsX;
    },
    columns() {
      return this.mappedDeck.columns || {};
    },
    aircraftMap() {
      return this.mappedDeck.aircraftMap || {};
    },
    allRows() {
      return Object.keys(this.aircraftMap);
    },
    numberedRows() {
      return this.mappedDeck.rows || {};
    },
    length() {
      return this.deckConfiguration.length + this.exitRows.length;
    },
    wingsInfo() {
      let startWingsRow = this.deckConfiguration.startWingsX || 0;
      let endWingsRow = this.deckConfiguration.endWingsX || 0;
      if (!this.deckConfiguration.startWingsX) {
        startWingsRow =
          (this.deckConfiguration.startWingsRow || 0) - (this.deckConfiguration.startSeatRow || 0);
        endWingsRow =
          (this.deckConfiguration.endWingsRow || 0) - (this.deckConfiguration.startSeatRow || 0);
      }

      const valid = startWingsRow < endWingsRow && endWingsRow > 0;
      if (valid) {
        startWingsRow += this.exitRows.reduce(
          (offset, exit) => (exit < startWingsRow ? offset + 1 : offset),
          0
        );
        endWingsRow += this.exitRows.reduce(
          (offset, exit) => (exit <= endWingsRow ? offset + 1 : offset),
          0
        );
      }

      return {
        aircraftLength: this.length,
        startWingsRow,
        endWingsRow,
        valid,
      };
    },
  },
};
</script>

<style lang="scss">
.airplane {
  display: flex;
  flex-grow: 1;
}

.deck {
  display: flex;
  flex-direction: column;
  gap: 5px;
  background-color: white;
  padding: 10px;

  border-left: 1px solid #e0e8ff;
  border-right: 1px solid #e0e8ff;
}
.deck-row-container {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.rows-display {
  border-radius: 10px;
  margin-bottom: 20px;
  border: 1px solid $light-gray;

  .rows-display-element {
    display: flex;
    align-items: center;
    justify-content: center;
    justify-items: center;
  }
}
</style>
